/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-07-10 10:16:15
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-13 15:56:46
 */

import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Modal, notification } from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { Query } from './Query'
import { columns } from './column'
import { DetailModal } from './detailModal'
import { getMaintenanceWorkOrderList } from './maintenanceWorkOrderSlice'
import { getDepartCountWithUserList } from '../../divisionManagement/divisionManagementSlice'
import moment from 'moment'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { getWorkOrderStatus } from '../../../models/workOrder'
import { FilenameListModal } from './lookPhotoModal'
import { getWorkTemplateData } from '../../workOrderTemplate/workOrderTemplateSlice'
import { deleteListFn } from '../demandWorkOrder/demandWorkOrderSlice'

export interface MaintenanceWorkOrderListRef {
  tabKey?: any
}

interface MaintenanceWorkOrderProps {
  tabKey?: any
}
const RealMaintenanceWorkOrderList = (
  { tabKey }: MaintenanceWorkOrderProps,
  ref: React.Ref<MaintenanceWorkOrderListRef>
): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [id, setId] = useState('')

  const [isDetailVisible, setIsDetailVisible] = useState(false)

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [departmentList, setDepartmentList] = useState<any>()

  const [data, setData] = useState<any>()

  const [topicsList, setTopicsList] = useState<any>()


  const [filenameList, setFilenameList] = useState<string>()

  const [isFilenameListVisible, setIsFilenameListVisible] = useState(false)

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [page, setPage] = useState({
    items: [],
    total: 0,
  })

  useEffect(() => {
    if (tabKey) {
      dispatch(getDepartCountWithUserList(''))
        .then(unwrapResult)
        .then((v) => {
          setDepartmentList(v)
        })
    }
  }, [])

  const getQueryPage = () => {
    dispatch(getWorkTemplateData({ current: 1, size: 10000 }))
      .then(unwrapResult)
      .then((v: any) => {
        setData(v?.records)
      })
  }

  useEffect(() => {
    if (data?.length) {
      const topics = data?.filter((v: any) => {
        return v?.name == '维修工单'
      })?.[0]?.topics


      setTopicsList(topics?.split(','))
    }
  }, [data])

  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getMaintenanceWorkOrderList({
        ...params,
        current: params.current,
        size: params.size,
        name: '维修工单',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (tabKey == '1') {
      getPage()
      getQueryPage()
    }
  }, [params, tabKey])

  const exportList = () => {
    const theader = [
      '工单编号',
      '审批部门',
      '申请人',
      '紧急程度',
      '报修主题',
      '报修地点',
      '具体内容',
      '提交时间',
      '状态',
    ]
    const filterVal = [
      'id',
      'departName',
      'submiter',
      'ermerge',
      'topics',
      'location',
      'describes',
      'updateTime',
      'status',
    ]
    dispatch(
      getMaintenanceWorkOrderList({
        ...params,
        current: 1,
        size: 10000,
        name: '维修工单',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const data = res.records
          .map((v: any) => ({
            ...v,
            updateTime: v.updateTime
              ? moment(v?.updateTime).format(DateTimeFormatSimple)
              : '-',
            status: v.status?.toString()
              ? getWorkOrderStatus(v.status?.toString())
              : '-',
          }))
          ?.map((s: any) => filterVal?.map((j: any) => s[j]))
        import('../../../ExportXLSX/Export2Excel').then((excel) => {
          excel.export_json_to_excel({
            header: theader,
            data,
            filename: '维修工单',
            autoWidth: true,
          })
        })
      })
  }

  return (
    <Col
      style={{
        height: 'calc(100% - 20px)',
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Col
        style={{
          flex: 1,
          backgroundColor: theme.pn,
          borderRadius: 10,
          padding: '15px  15px 0 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Query
          topicsList={topicsList}
          departmentList={departmentList}
          export={() => {
            exportList()
          }}
          onValueChange={(v: any) => {
            setParams({
              ...params,
              ...v,
              current: 1,
              startTime: v?.timeHead,
              endTime: v?.timeTail,
              timeHead: undefined,
              timeTail: undefined,
            })
          }}
        />
        <EditableList
          rowKey={(_: any, i: any) => `${i}}`}
          page={{
            items: page.items,
            current: params.current,
            size: params.size,
            total: page.total,
          }}
          loading={pageLoading}
          columns={columns((action: any, v: any) => {
            switch (action) {
              case 'lookDetail':
                setIsDetailVisible(true)
                setId(v.id)
                break
              case 'lookPhoto':
                setFilenameList(v?.urls)
                setIsFilenameListVisible(true)
                break
              case 'delete':
                Modal.confirm({
                  content: `是否删除？`,
                  cancelText: '取消',
                  okText: '确认',
                  onOk: () =>
                    dispatch(
                      deleteListFn(v?.id)
                    )
                      .then(unwrapResult)
                      .then((v) => {
                        notification.success({
                          message: '操作成功',
                          duration: 3,
                        })
                        getPage()
                      }),
                })

                break
            }
          }, params.size * (params.current - 1))}
          onChangePage={(current, size) => {
            setParams({ ...params, current, size: size || 10 })
          }}
        />
      </Col>
      <DetailModal
        id={id}
        visible={isDetailVisible}
        onCancel={() => {
          setIsDetailVisible(false)
          setId('')
          getPage()
        }}
        onOk={() => {
          setIsDetailVisible(false)
          setId('')
          getPage()
        }}
      />
      <FilenameListModal
        filename={filenameList}
        visible={isFilenameListVisible}
        onCancel={() => {
          setIsFilenameListVisible(false)
          setFilenameList('')
          getPage()
        }}
        onOk={() => {
          setIsFilenameListVisible(false)
          setFilenameList('')
          getPage()
        }}
      />
    </Col>
  )
}

export const MaintenanceWorkOrderList = forwardRef(RealMaintenanceWorkOrderList)
